import { useMemo } from 'react'
import { INTEGRATIONS_REQUIRING_USER_CONNECTION } from '../../common/integrationRequirement'
import { IntegrationServiceId } from '../../common/integrations'
import { isSupportedMeetingProvider } from '../../common/meetingProviders'
import { useIntegrationRequirement } from '../../common/useIntegrationRequirement'

export type CantJoinTooltipType = 'zoom-obf' | 'integration-requirement' | 'none'

interface CantJoinTooltipResult {
  serviceId: IntegrationServiceId | undefined
  tooltipType: CantJoinTooltipType
}

export const useCantJoinTooltip = (source?: string): CantJoinTooltipResult => {
  const checkRequirement = useIntegrationRequirement()

  return useMemo(() => {
    const serviceId = source ? (source as IntegrationServiceId) : undefined
    const isSupported = source ? isSupportedMeetingProvider(source) : false

    if (!serviceId || !isSupported || !INTEGRATIONS_REQUIRING_USER_CONNECTION.has(serviceId)) {
      return { serviceId, tooltipType: 'none' as const }
    }

    const { accountAllowed } = checkRequirement(serviceId)
    const tooltipType: CantJoinTooltipType = serviceId === IntegrationServiceId.ZOOM && accountAllowed ? 'zoom-obf' : 'integration-requirement'

    return { serviceId, tooltipType }
  }, [source, checkRequirement])
}
